enum BoundaryLegendClassificationType {
  NATURAL_BREAKS = "Natural",
  QUANTILE = "Quantile",
  EQUAL_INTERVAL = "EqualInterval",
  MANUAL = "Manual",
  SIMPLE = "Simple", // not mentioned in Docs, but found in wildlife
}

export default BoundaryLegendClassificationType;
